/**
 * `error_code` values `/consent-done` understands.
 *
 * Shared rather than declared per page because two files now speak this vocabulary:
 * ActivateDelegatedPage mints one of them, and ConsentDonePage maps them to caption keys.
 */

/**
 * Appended by the **backend** when the consenting Microsoft account does not match the Printix
 * user the consent was issued to. Observed against dev02.
 */
export const DELEGATED_CONSENT_USER_MISMATCH = 'DELEGATED_CONSENT_USER_MISMATCH';

/**
 * Appended by the **app**, not the backend: ActivateDelegatedPage stops an activation whose
 * link was minted for a tenant this session is not signed in to, and sends the user here
 * instead of calling an endpoint that can only answer 403/404.
 *
 * Deliberately shaped like the backend's own codes so `/consent-done` has one failure
 * vocabulary rather than two. Nothing downstream trusts the value — it selects a constant
 * caption key and is sanitized before it is logged — so a hand-crafted `/consent-done` link
 * carrying it can do no more than show the user a message.
 */
export const DELEGATED_CONSENT_WRONG_TENANT = 'DELEGATED_CONSENT_WRONG_TENANT';
